import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] grid-pattern flex items-center justify-center px-6">
      <div className="max-w-md w-full border border-white/10 bg-[#0F0F0F] p-10 text-center">
        <CheckCircle2 className="w-12 h-12 text-[#D3FF24] mx-auto mb-6" strokeWidth={1.5} />
        <h1 className="font-display text-3xl font-bold tracking-tight mb-2">Payment confirmed</h1>
        <p className="text-neutral-400 text-sm mb-8">Your plan is now active. Time to ace some interviews.</p>
        <Link to="/app" data-testid="goto-dashboard"
          className="block bg-[#D3FF24] text-black py-3 text-xs uppercase tracking-widest font-semibold hover:brightness-105">
          Go to dashboard
        </Link>
      </div>
    </div>
  );
}
